var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M51.227,196.022c2.372-32.418,23.068-51.379,76.543-62.913 c53.476-11.534,33.553-74.446,83.883-91.223s63.961,28.311,91.223,45.087c27.262,16.777,94.563-17.534,126.874,32.505 c32.311,50.039-62.913,91.223-36.699,144.699c26.214,53.476,0,128.971-55.573,158.33c-24.912,13.161-51.379,7.34-88.077-1.048 c-36.699-8.388-67.107,15.728-103.806-2.097c-36.699-17.825-15.728-105.903-30.408-136.31 C100.508,252.644,48.081,239.013,51.227,196.022z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M454.92,358.36v0.03c-0.01,1.64-1.4,2.95-3.05,2.95H392v-37.73c0.28-0.01,0.57-0.02,0.86-0.02 c6.16,0,11.76,2.84,15.9,7.46c2.24-1.05,4.67-1.65,7.23-1.65c8.19,0,15.19,5.95,18.07,14.37c2.01-1.28,4.3-2.01,6.74-2.01 C448.59,341.76,454.92,349.19,454.92,358.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M71.923,344.566c-1.554,0-2.869-1.382-2.871-3.121c0-0.011,0-0.022,0-0.032 c0-9.674,5.963-17.516,13.319-17.516c2.3,0,4.464,0.767,6.352,2.117c2.721-8.884,9.325-15.163,17.055-15.163 c2.411,0,4.708,0.627,6.817,1.737c3.91-4.872,9.186-7.866,14.997-7.866c7.918,0,14.849,5.548,18.672,13.848 c3.357-4.738,8.13-7.719,13.444-7.719c10.157,0,18.392,10.829,18.392,24.187c0,2.505-0.292,4.919-0.83,7.191 c-0.33,1.39-1.482,2.337-2.768,2.337H71.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M214.202,111.091c1.647,0,3.041-1.309,3.044-2.957c0-0.01,0-0.02,0-0.031 c0-9.165-6.321-16.594-14.118-16.594c-2.438,0-4.732,0.727-6.733,2.006c-2.884-8.417-9.884-14.365-18.078-14.365 c-2.556,0-4.99,0.594-7.226,1.645c-4.144-4.615-9.736-7.452-15.896-7.452c-8.392,0-15.74,5.256-19.791,13.119 c-3.559-4.489-8.618-7.313-14.25-7.313c-10.766,0-19.494,10.259-19.494,22.914c0,2.373,0.309,4.661,0.88,6.812 c0.349,1.317,1.571,2.215,2.934,2.215H214.202z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#00AB65",
      stroke: "#00AB65",
      strokeMiterlimit: 10
    },
    cx: 295.436,
    cy: 390.582,
    rx: 126.423,
    ry: 12.004
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M392,121.81V374.5c0,6.47-5.24,11.72-11.71,11.72H247.83c-6.47,0-11.71-5.25-11.71-11.72V121.81 c0-1.41,0.25-2.77,0.71-4.02c1.64-4.49,5.95-7.69,11-7.69h132.46c5.05,0,9.36,3.2,11,7.69C391.75,119.04,392,120.4,392,121.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M391.29,117.79c-1.64-4.49-5.95-7.69-11-7.69h-33.205c0.043-0.149,0.063-0.233,0.063-0.233 l-66.175,0.058c0,0,0.012,0.068,0.034,0.174H247.83c-5.05,0-9.36,3.2-11,7.69h47.797c4.014,5.477,12.264,11.714,28.967,11.184 c16.033-0.509,24.551-6.159,28.99-11.184H391.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.206,118.78c0,1.737-1.408,3.146-3.146,3.146s-3.146-1.408-3.146-3.146 c0-1.737,1.408-3.146,3.146-3.146S317.206,117.043,317.206,118.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M392,358.26v16.24c0,6.47-5.24,11.72-11.71,11.72H247.83c-6.47,0-11.71-5.25-11.71-11.72v-16.24 H392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65",
      stroke: "#00AB65",
      strokeMiterlimit: 10
    },
    d: "M326.992,377.42h-25.864c-3.861,0-6.99-3.13-6.99-6.99l0,0 c0-3.861,3.13-6.99,6.99-6.99h25.864c3.861,0,6.99,3.13,6.99,6.99l0,0C333.982,374.29,330.853,377.42,326.992,377.42z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M251.73,292.6c-3.79,5.24-10.85,13.4-15.61,18.79V190.81c2.01,2.21,15.78,18.02,11.88,31.43 c-4.19,14.44-3.26,30.29,0.93,39.14C253.13,270.24,257.79,284.22,251.73,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#00AB65",
      strokeMiterlimit: 10
    },
    d: "M392,121.81V374.5c0,6.47-5.24,11.72-11.71,11.72H247.83 c-6.47,0-11.71-5.25-11.71-11.72V121.81c0-1.41,0.25-2.77,0.71-4.02c1.64-4.49,5.95-7.69,11-7.69h132.46c5.05,0,9.36,3.2,11,7.69 C391.75,119.04,392,120.4,392,121.81z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M371.556,280.488c0,4.054-27.829,7.34-54.757,7.34c-26.928,0-48.757-3.286-48.757-7.34 c0-4.054,21.829-7.34,48.757-7.34C343.727,273.148,371.556,276.435,371.556,280.488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5EBF5"
    },
    d: "M375.39,258.16l0.03,0.14l-53.54,14.89c-1.67-0.03-3.36-0.04-5.08-0.04 c-12.59,0-24.09,0.72-32.74,1.9l-10.75-38.64l7.68-9.01l-0.97-3.49l5.18-1.44l23.64-27.73l35.83,11.19l2.01-0.57l0.37,1.31 l15.62,4.88l-0.23,0.06l0.03,0.11l0.2-0.17l12.99,46.68L375.39,258.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEF8F2"
    },
    d: "M321.88,273.19l-35.58,9.9l-2.24-8.04c8.65-1.18,20.15-1.9,32.74-1.9 C318.52,273.15,320.21,273.16,321.88,273.19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 272.989,
    y: 219.396,
    transform: "matrix(0.9634 -0.268 0.268 0.9634 -53.6201 94.4869)",
    style: {
      fill: "#FDC153"
    },
    width: 92.508,
    height: 48.456
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC153"
    },
    points: "268.188,232.681 303.715,191.013 357.546,207.819  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.92,
    y: 210.324,
    transform: "matrix(0.9634 -0.268 0.268 0.9634 -49.2325 92.0531)",
    style: {
      fill: "#FCF6DE"
    },
    width: 69.197,
    height: 32.023
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD359"
    },
    points: "319.295,241.07 281.176,279.364 268.188,232.681  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD359"
    },
    points: "318.116,241.398 370.534,254.502 357.546,207.819  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6545"
    },
    cx: 349.537,
    cy: 206.683,
    r: 11.908
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M345.41,209.799h2.89v-5.71h-2.437v-1.846c1.566-0.244,2.332-0.522,3.238-1.079h2.193v8.635 h2.369v2.403h-8.253V209.799z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M272.935,198.935c0,1.93-1.565,3.495-3.495,3.495c-1.93,0-3.495-1.565-3.495-3.495 c0-1.93,1.565-3.495,3.495-3.495C271.37,195.44,272.935,197.005,272.935,198.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M335.347,185.05c0,2.735-2.217,4.952-4.952,4.952c-2.735,0-4.952-2.217-4.952-4.952 c0-2.735,2.217-4.952,4.952-4.952C333.129,180.098,335.347,182.315,335.347,185.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00AB65"
    },
    d: "M305.27,318.457c0,3.695-2.996,6.691-6.691,6.691c-3.695,0-6.691-2.996-6.691-6.691 c0-3.695,2.996-6.691,6.691-6.691C302.275,311.766,305.27,314.762,305.27,318.457z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#78457E"
    },
    points: "291.024,170.261 292.817,164.03 294.611,170.261 298.754,172.054 294.611,173.847  292.817,180.078 291.024,173.847 286.881,172.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#78457E"
    },
    points: "356.585,304.721 358.378,298.491 360.172,304.721 364.315,306.514 360.172,308.308  358.378,314.538 356.585,308.308 352.442,306.514  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#572F63"
    },
    d: "M208.333,377.77c0,0-15.728,5.942-16.078,8.039c-0.114,0.686-0.135,1.559-0.111,2.424 c0.054,1.957,1.652,3.518,3.611,3.518h24.138c1.831,0,3.365-1.37,3.586-3.187c0.251-2.064,0.439-4.521,0.059-5.376 c-0.699-1.573-3.67-5.418-3.67-5.418H208.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M219.867,377.77c0,0-1.223,1.748-5.592,1.398c-4.369-0.349-5.942-1.398-5.942-1.398v-8.913 h11.534V377.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF2E"
    },
    d: "M195.226,278.508l9.087,90.524c0,0,2.796,2.971,8.913,2.971c6.117,0,9.612-3.32,9.612-3.32 l-8.388-87.903L195.226,278.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#572F63"
    },
    d: "M244.508,358.08c0,0-6.701,15.42-5.441,17.132c0.013,0.017,0.025,0.034,0.038,0.052 c1.888,2.509,5.622,2.65,7.811,0.398l14.676-15.101c1.88-1.934,1.967-4.983,0.206-7.027c-1.056-1.226-2.147-2.337-2.81-2.581 c-1.615-0.595-6.443-1.144-6.443-1.144L244.508,358.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M252.547,349.809c0,0,0.401,2.095-2.895,4.985c-3.296,2.889-5.144,3.286-5.144,3.286 l-6.391-6.212l8.039-8.271L252.547,349.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED45A"
    },
    d: "M208.857,280.954c0,0-20.039,36.349-10.718,45.67c9.32,9.32,39.612,28.427,39.612,28.427 s2.913-1.573,6.757-6.291c3.845-4.719,3.845-6.466,3.845-6.466s-15.029-18.349-17.476-20.097 c-2.447-1.747-8.913-4.544-8.913-4.544s13.806-16.078,17.65-24.116c3.845-8.039-3.845-15.029-3.845-15.029L208.857,280.954z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M228.72,278.86c-0.18,0.81-0.39,1.29-0.64,1.4c-3.67,1.57-22.89,0.34-22.89,0.34v-0.61 c0.25,0.04,0.41,0.07,0.48,0.08l0.04,0.01c0,0,2.8-11.07,4.87-23.39c3.67-1.45,9.02-4.15,14.03-7.58l1.02,13.84 c0,0-1.11,11.6,2.89,15.71C228.58,278.73,228.65,278.8,228.72,278.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.73,195.24c-1.08,4.03-2.45,15.15-2.45,18.96c0,3.99-4.11,15.94-12.54,23.15 c0.09-3.64-0.11-6.82-0.74-9.17c-3.49-13.11-0.35-27.43,2.36-32.94c0,0,1.75,1.83,6.56,2.01 C225.72,197.42,227.73,195.24,227.73,195.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M153.975,257.171c0,0,6.043,0.138,6.181-0.656c0.138-0.794-0.898-3.384-0.898-3.384 S155.737,251.266,153.975,257.171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78457E"
    },
    d: "M212,228.18c0.63,2.35,0.83,5.53,0.74,9.17c-0.15,5.79-1.05,12.74-2.16,19.34 c-2.07,12.32-4.87,23.39-4.87,23.39l-0.04-0.01c-0.07-0.01-0.23-0.04-0.48-0.08c-1.98-0.32-9.11-1.64-12.14-3.88 c-0.68-0.49-1.15-1.03-1.32-1.62c-0.89-3.12,1.12-7.24,3.03-12.06c0.34-0.85,0.67-1.73,0.99-2.62c1.08-3.07,1.8-9.54,2.23-15.09 c0.41-5.18,0.57-9.55,0.57-9.55s-1.72,4.86-7.99,11.86c-0.66,0.74-1.38,1.5-2.15,2.29c-1.84,1.88-4.14,3.36-6.59,4.52 c-8.25,3.91-18.22,4.22-18.22,4.22s-1.23-9.61-0.88-11.01c0.35-1.4,5.24-4.19,13.28-6.29c8.04-2.1,14.68-21.32,22.72-32.5 c8.04-11.19,15.64-13.02,15.64-13.02C211.65,200.75,208.51,215.07,212,228.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6142"
    },
    d: "M205.19,285.32c-0.7,0.35-13.63-2.09-13.81-3.14c-0.15-0.92,1.31-5.07,1.67-6.07 c3.41,2.52,11.99,3.87,12.62,3.96l0.04,0.01C205.71,280.08,205.89,284.97,205.19,285.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6142"
    },
    d: "M162.721,248.566c0,0-4.078-0.466-4.078,0.932c0,1.398,0.233,7.456,1.165,7.573 c0.932,0.117,3.743-0.014,3.743-0.014L162.721,248.566z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 138.832,
    y: 239.162,
    transform: "matrix(0.5555 -0.8315 0.8315 0.5555 -144.549 231.8826)",
    style: {
      fill: "#572F63"
    },
    width: 11.535,
    height: 23.945
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.204,
    y: 242.009,
    transform: "matrix(0.5555 -0.8315 0.8315 0.5555 -144.549 231.8812)",
    style: {
      fill: "#FFFFFF"
    },
    width: 8.791,
    height: 18.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B1730"
    },
    d: "M154.278,256.677c0,0.42-0.34,0.76-0.76,0.76c-0.42,0-0.76-0.34-0.76-0.76 c0-0.419,0.34-0.76,0.76-0.76C153.938,255.918,154.278,256.258,154.278,256.677z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M158.697,250.26c0,0-6.841-1.531-6.646,0.233c0.195,1.764,6.777,2.826,6.777,2.826 L158.697,250.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78457E"
    },
    d: "M250.27,279.56c-1.22,4.37-1.74,4.54-1.74,4.54s-14.68-1.05-19.4-4.54 c-0.14-0.1-0.28-0.22-0.41-0.35c-0.07-0.06-0.14-0.13-0.2-0.2c-4-4.11-2.89-15.71-2.89-15.71l-1.02-13.84 c1.69-1.15,3.34-2.39,4.87-3.7c2.17-1.84,4.11-3.82,5.59-5.87c1.62-2.26,3.128-6.906,4.428-10.896 c0.07,1.72,1.082,24.206,3.092,29.246C244.68,263.479,251.5,275.19,250.27,279.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6142"
    },
    d: "M248.53,283.75c0,0-2.27,6.29-3.32,6.64c-1.05,0.35-17.3-5.59-18.53-6.29 c-1.22-0.7,1.23-5.59,1.23-5.59l0.61,0.15c0.18,0.2,0.39,0.39,0.61,0.55C233.85,282.7,248.53,283.75,248.53,283.75z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M177.401,257.362c0,0-10.66,0-10.66,1.223c0,1.223,3.67,1.922,3.67,1.922 s-6.466,0.699-6.466,1.573c0,0.874,4.194,0.699,4.194,0.699s-4.718,0.524-4.893,1.573c-0.175,1.048,6.466,0.699,6.466,0.699 s-3.845,1.049-3.845,1.922c0,0.874,4.194-0.175,4.194-0.175s-1.922,0.874-1.922,1.573c0,0.699,9.437-1.748,11.709-4.194 C182.119,261.731,177.401,257.362,177.401,257.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#78457E"
    },
    d: "M239.61,229.86c-1.3,3.99-2.92,7.42-4.54,9.68c-1.48,2.05-3.42,4.03-5.59,5.87 c-1.53,1.31-3.18,2.55-4.87,3.7c-5.01,3.43-10.36,6.13-14.03,7.58c-1.85,0.74-3.27,1.16-3.99,1.2c-0.37,0.02-0.83,0.1-1.34,0.24 c-2.61,0.66-6.8,2.62-10.49,4.3c-2.04,0.93-3.92,1.78-5.3,2.27c-4.37,1.57-5.24-1.4-6.99-5.42c-0.9-2.07-0.93-3.94-0.65-5.44 c0.27-1.41,0.81-2.5,1.17-3.12c0.89-1.53,3.66-2.5,7.57-3.69c2.17-0.66,4.69-1.39,7.42-2.31c2.31-0.78,4.77-1.7,7.31-2.85 c0.77-0.35,1.55-0.72,2.34-1.11c1.85-0.92,3.55-2.09,5.11-3.41c8.43-7.21,12.54-19.16,12.54-23.15c0-3.81,1.37-14.93,2.45-18.96 c0.02-0.08,0.04-0.15,0.06-0.22v-0.01c0.24-0.82,0.45-1.29,0.64-1.26C243.43,196.05,244.05,216.22,239.61,229.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#AD6BB5",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M238.847,232.041 c-1.145,3.054-2.461,5.663-3.777,7.499c-1.48,2.05-3.42,4.03-5.59,5.87c-1.53,1.31-3.18,2.55-4.87,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD6142"
    },
    d: "M182.294,252.382c0,0-5.709,1.893-5.359,3.408c0.35,1.515,2.447,9.903,3.728,9.903 c1.282,0,4.427-1.515,4.427-1.515L182.294,252.382z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M227.73,173.39v21.95c0,0-2.01,2.07-6.81,1.91c-4.81-0.17-6.56-1.91-6.56-1.91v-21.95H227.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M228.08,166.23c0,0.3,0,0.61-0.02,0.92c-0.01,0.44-0.02,0.88-0.05,1.32c0,0.01,0,0.02,0,0.02 c-0.02,0.34-0.04,0.67-0.07,1.01c-0.07,0.96-0.18,1.9-0.32,2.81c-0.04,0.25-0.08,0.51-0.13,0.76c-0.01,0.08-0.02,0.17-0.04,0.25 c0,0.02-0.01,0.04-0.01,0.07c-0.01,0.06-0.02,0.12-0.04,0.18c-0.05,0.29-0.11,0.58-0.17,0.87c0,0,0,0-0.01,0 c-0.76,3.54-2,6.69-3.6,9.19c-0.22,0.35-0.45,0.69-0.69,1.01c-0.78,1.09-1.65,2.04-2.57,2.81c-1.79,1.49-3.79,2.33-5.91,2.33 h-0.09c-2.01-0.02-3.92-0.8-5.63-2.17c-4.5-3.6-7.67-11.3-7.89-20.32c-0.02-0.35-0.02-0.71-0.02-1.06c0-2.63,0.12-5.17,0.41-7.53 c0.16-1.33,0.38-2.6,0.65-3.82c1.62-7.28,5.32-12.22,12.57-12.22c10.22,0,12.81,6.72,13.44,16.04 C228.05,161.06,228.08,163.6,228.08,166.23z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#71BD9F"
    },
    d: "M229.076,158.698h-29.033c0.131-1.085,0.294-2.14,0.501-3.153 c0.054-0.279,0.109-0.558,0.174-0.837c0.011-0.052,0.022-0.114,0.033-0.165c1.764-7.93,5.794-13.306,13.689-13.306 C225.57,141.236,228.39,148.545,229.076,158.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#83DBB8",
      strokeWidth: 0.7,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M220.657,153.884 c0,0,2.791-0.361,2.791,4.577"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#412444"
    },
    d: "M215.757,146.898h-0.985c-3.056,0-5.534,2.478-5.534,5.534v1.693h12.053v-1.693 C221.291,149.376,218.813,146.898,215.757,146.898z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M233.32,170.98c-0.11,2.76-3.14,3.53-5.36,3.53c-0.08,0-0.16,0-0.23-0.01 c-0.18,0-0.35-0.02-0.5-0.06c0.06-0.29,0.12-0.58,0.17-0.87c0.02-0.06,0.03-0.12,0.03-0.18c0.01-0.02,0.02-0.05,0.02-0.07 c0.02-0.08,0.03-0.17,0.04-0.25c0.05-0.25,0.09-0.5,0.13-0.76c0.14-0.91,0.25-1.85,0.32-2.81c0.03-0.33,0.05-0.67,0.07-1.01 c0,0,0-0.01,0-0.02c0.03-0.43,0.04-0.88,0.05-1.32c0.52-0.24,1.1-0.37,1.71-0.37C231.99,166.78,233.44,168.21,233.32,170.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBBA99"
    },
    d: "M196.711,170.921c0.09,2.26,2.568,2.888,4.384,2.888c0.229,0,0.425-0.023,0.597-0.062 c-0.401-1.871-0.638-3.874-0.679-5.963c-0.425-0.194-0.9-0.303-1.399-0.303C197.799,167.481,196.613,168.654,196.711,170.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#412444"
    },
    d: "M205.7,158.698c-0.95,6.75-4.56,8.459-4.86,8.592c-0.02-0.351-0.02-0.712-0.02-1.063 c0-2.63,0.12-5.164,0.41-7.528H205.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#412444"
    },
    d: "M228.08,166.226c0,0.304,0,0.617-0.02,0.921c-0.02,0.892-0.06,1.775-0.14,2.649 c-0.06-0.019-0.12-0.057-0.19-0.085c-4.8-2.411-4.89-10.87-4.89-10.87l5.05-0.142C228.05,161.062,228.08,163.596,228.08,166.226z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB5F50"
    },
    d: "M222.93,184.643c-0.05,0.18-0.11,0.38-0.18,0.579c-2.2,6.484-6.19,7.272-8.39,7.148v-2.592h0.09 c2.12,0,4.12-0.835,5.91-2.326C221.28,186.684,222.15,185.735,222.93,184.643z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeWidth: 0.6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M206.127,167.139 c0,0-0.934,3.368,1.479,3.197c2.414-0.171,1.791-3.14,1.791-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeWidth: 0.6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M215.039,167.139 c0,0-0.934,3.368,1.479,3.197c2.414-0.171,1.791-3.14,1.791-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeWidth: 0.6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M212.09,166.139 c0,0-0.016,2.784-0.437,5.143c-0.287,1.608-1.107,2.129-0.961,3.152c0.146,1.023,2.621,0.83,2.621,0.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeWidth: 0.6,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M209.272,177.421 c0,0-0.63,3.484,3.149,3.235c3.779-0.249,2.939-3.484,2.939-3.484"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FB8378"
    },
    cx: 205.974,
    cy: 175.015,
    rx: 1.66,
    ry: 1.576
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8378"
    },
    d: "M221.832,175.015c0,0.87-0.743,1.576-1.66,1.576s-1.66-0.706-1.66-1.576 c0-0.87,0.743-1.576,1.66-1.576S221.832,174.145,221.832,175.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB8378"
    },
    d: "M220.36,187.453c-1.79,1.49-3.79,2.326-5.91,2.326c-2.04,0-3.98-0.779-5.72-2.174 C210.95,186.637,215.61,185.213,220.36,187.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M205.129,163.679 c0,0,2.447-1.659,4.893,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#412444",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M214.275,163.623 c0,0,2.447-1.659,4.893,0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2CAB79"
    },
    d: "M234.49,174.24c-1.21,2.63-4.13,6.53-6.76,8.55v-8.29c0.07,0.01,0.15,0.01,0.23,0.01 c2.22,0,5.25-0.77,5.36-3.53c0.12-2.77-1.33-4.2-3.55-4.2c-0.61,0-1.19,0.13-1.71,0.37c0.02-0.31,0.02-0.62,0.02-0.92 c0-2.63-0.03-5.17-0.19-7.53C227.89,158.7,236.47,169.93,234.49,174.24z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#A169B0",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M124.1,191.968 c0-12.946,12.858-23.44,28.718-23.44c15.861,0,28.718,10.495,28.718,23.44c0,12.946-12.858,23.44-28.718,23.44 c-3.168,0-6.208-0.435-9.058-1.209c-0.206,1.396-0.859,6.866,0.753,11.299C144.514,225.498,124.1,212.624,124.1,191.968z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDC153"
    },
    points: "165.254,200.394 137.975,201.447 137.477,185.597 164.757,184.544  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD359"
    },
    points: "151.557,192.187 137.975,201.447 137.477,185.597  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD359"
    },
    points: "151.196,192.201 165.326,200.391 164.829,184.541  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6545"
    },
    d: "M168.547,183.634c0,2.669-2.163,4.832-4.832,4.832c-2.668,0-4.832-2.163-4.832-4.832 c0-2.668,2.163-4.832,4.832-4.832C166.384,178.802,168.547,180.965,168.547,183.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M162.041,184.898h1.173v-2.317h-0.989v-0.749c0.636-0.099,0.946-0.212,1.314-0.438h0.89v3.503 h0.961v0.975h-3.349V184.898z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "196.178,343.404 191.229,343.953 190.98,341.381 195.84,340.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "185.271,344.401 180.298,344.604 180.227,342.077 185.121,341.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "174.326,344.643 169.35,344.505 169.451,342.037 174.35,342.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "163.386,344.128 158.432,343.632 158.707,341.235 163.582,341.696  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "152.511,342.812 147.606,341.934 148.058,339.622 152.882,340.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "141.767,340.639 136.95,339.35 137.583,337.14 142.317,338.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "131.243,337.546 126.565,335.822 127.381,333.733 131.976,335.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "121.057,333.482 116.569,331.302 117.564,329.357 121.971,331.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "111.326,328.41 107.091,325.771 108.256,323.99 112.416,326.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "102.187,322.331 98.265,319.246 99.581,317.647 103.438,320.648  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "93.769,315.289 90.21,311.791 91.653,310.386 95.158,313.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "86.174,307.369 83.013,303.511 84.553,302.303 87.674,306.072  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "79.467,298.693 76.72,294.538 78.326,293.522 81.047,297.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "73.67,289.4 71.329,285.007 72.971,284.169 75.298,288.483  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "68.757,279.618 66.806,275.047 68.459,274.372 70.408,278.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "64.683,269.473 63.092,264.77 64.737,264.238 66.334,268.878  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "61.418,259.034 60.268,254.187 61.902,253.836 63.059,258.599  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "59.203,248.303 58.592,243.356 60.199,243.196 60.824,248.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "58.207,237.387 58.187,232.402 59.744,232.435 59.79,237.333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "58.53,226.431 59.124,221.482 60.609,221.7 60.05,226.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "60.205,215.601 61.407,210.767 62.799,211.15 61.642,215.912  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "63.197,205.065 64.965,200.412 66.249,200.935 64.531,205.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "67.402,194.96 69.678,190.538 70.847,191.172 68.624,195.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "72.684,185.384 75.399,181.222 76.451,181.937 73.788,186.066  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "78.892,176.39 81.981,172.502 82.919,173.275 79.881,177.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "85.888,168.003 89.296,164.394 90.125,165.203 86.766,168.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "93.558,160.232 97.242,156.907 97.968,157.735 94.33,161.053  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "101.814,153.094 105.749,150.071 106.371,150.91 102.484,153.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A169B0"
    },
    points: "110.704,146.607 112.836,145.262 113.345,146.123 111.262,147.453  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC153"
    },
    d: "M122.703,146.559c0,0-28.208-4.737-28.8-4.26c-0.592,0.477-1.621,8.685-1.621,8.685 L122.703,146.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD359"
    },
    d: "M122.703,146.559c0,0-36.222,2.402-37.455,4.755c-1.233,2.353-3.13,21.163-1.936,21.074 S122.703,146.559,122.703,146.559z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInvite);
export default __webpack_public_path__ + "static/media/user_invite.38b177ef96fdc4cc63a0d373b33ac690.svg";
export { ForwardRef as ReactComponent };